import { createSlice, isRejected, isPending, isFulfilled } from '@reduxjs/toolkit'

export type LoadingState = {
  fetchingActions: Record<string, boolean>
  errorActions: Record<string, string>
}

type RejectedActionWithError = {
  type: string
  error: {
    message?: string | undefined
  }
}

const initialState: LoadingState = {
  fetchingActions: {},
  errorActions: {},
}

const isPendingAction = (action: { payload: any; type: string }) => isPending(action)

const isFulfilledAction = (action: { payload: any; type: string }) => isFulfilled(action)

const isRejectedAction = (action: { payload: any; type: string }) => isRejected(action)

export const loadingSlice = createSlice({
  name: 'currentLoading',
  initialState,
  reducers: {
    clearError: (state, action) => {
      action.payload.foreach((requestName: string) => {
        state.errorActions[requestName] = ''
      })
    },
    clearAllErrors: (state) => {
      state.errorActions = {}
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(isPendingAction, (state, action) => {
        const { type } = action
        const matches = /(.*)\/(pending)/.exec(type)
        if (matches) {
          const [, requestName] = matches
          state.fetchingActions[requestName] = true
        }
      })
      .addMatcher(isFulfilledAction, (state, action) => {
        const { type } = action
        const matches = /(.*)\/(fulfilled)/.exec(type)
        if (matches) {
          const [, requestName] = matches
          state.fetchingActions[requestName] = false
          state.errorActions[requestName] = ''
        }
      })
      .addMatcher(isRejectedAction, (state, action: RejectedActionWithError) => {
        const { type, error } = action
        const matches = /(.*)\/(rejected)/.exec(type)
        if (matches) {
          const [, requestName] = matches
          state.fetchingActions[requestName] = false
          state.errorActions[requestName] = error?.message || 'Unknown error'
        }
      })
  },
})

export default loadingSlice.reducer
